import { useEffect, useState } from "react";
import axios from "axios";
import { Users } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LiveSocialProof({ variant = "hero" }) {
  const [data, setData] = useState({ active_now: 0, today: 0, lifetime: 500 });

  useEffect(() => {
    let mounted = true;
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API}/live-stats`);
        if (mounted) setData(res.data);
      } catch {
        /* fail silently — this is just social proof */
      }
    };
    fetchStats();
    const id = setInterval(fetchStats, 30000); // refresh every 30s
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  if (variant === "pill") {
    return (
      <div
        data-testid="live-proof-pill"
        className="inline-flex items-center gap-2 bg-[#0A0A0A]/80 backdrop-blur-xl border border-[#D4AF37]/30 px-3 py-1.5 text-xs"
      >
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400"></span>
        </span>
        <span className="text-white/80">
          <span className="text-[#D4AF37] font-semibold">{data.active_now}</span> conversando agora
        </span>
      </div>
    );
  }

  // Default: hero variant with richer info
  return (
    <div
      data-testid="live-proof-hero"
      className="inline-flex items-center gap-3 bg-[#0A0A0A]/70 backdrop-blur-xl border border-[#D4AF37]/25 px-4 py-2.5 shadow-[0_4px_24px_rgba(0,0,0,0.4)]"
    >
      <span className="relative flex h-2.5 w-2.5 flex-shrink-0">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-400"></span>
      </span>
      <div className="flex items-center gap-3 text-xs md:text-sm">
        <div className="text-white/85">
          <span className="text-[#D4AF37] font-semibold">{data.active_now}</span>
          <span className="ml-1.5 text-white/60">conversando agora</span>
        </div>
        <div className="w-px h-4 bg-white/15" />
        <div className="text-white/85 hidden sm:flex items-center gap-1.5">
          <Users size={12} strokeWidth={1.75} className="text-[#D4AF37]" />
          <span className="text-[#D4AF37] font-semibold">{data.today}</span>
          <span className="ml-0.5 text-white/60">atendidas hoje</span>
        </div>
      </div>
    </div>
  );
}
